
import * as fb from "../firebase";

export const checkUserExists = async (uid: string): Promise<boolean> => {
    const doc = await fb.users.doc(uid).get();

    return doc.exists;
}